/**
 * IT Companies - Contracts Page
 * Manage recurring software and service contracts
 */

import { useEffect } from 'react';
import { AllContractsPage } from '@/components/industry/pages/AllContractsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function ITContractsPage() {
  useEffect(() => {
    document.title = 'Contratos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <AllContractsPage
      domain={CompanyType.IT_COMPANIES}
      pageTitle="Contratos de Software"
      pageDescription="Gerencie contratos recorrentes de software e serviços de TI"
    />
  
    </MainLayout>);
}

